import { render, staticRenderFns } from "./turrezervasyon.vue?vue&type=template&id=5ab17615&"
import script from "./turrezervasyon.vue?vue&type=script&lang=js&"
export * from "./turrezervasyon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports